export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-monitor-b714e61feb8f743721d7ba47a1c34824.svg";